import { render, staticRenderFns } from "./PageContentLayout.vue?vue&type=template&id=f348e18a&"
import script from "./PageContentLayout.vue?vue&type=script&lang=js&"
export * from "./PageContentLayout.vue?vue&type=script&lang=js&"
import style0 from "./PageContentLayout.vue?vue&type=style&index=0&id=f348e18a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports